<template>
  <v-card v-if="my_forms.length > 0" class="mt-5" outlined>
    <v-card-title class="d-flex align-center">
      <v-icon class="mr-2" color="primary">mdi-printer</v-icon>
      <span>Printable Forms</span>
      <v-spacer />
      <v-btn icon @click="refresh" :loading="loading">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-list dense two-line>
        <v-list-item v-for="form in my_forms" :key="form.id">
          <v-list-item-content>
            <v-list-item-title>
              Form {{ form.form_number }} &mdash; {{ form.title }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="form.om_part">
              OM Part {{ form.om_part }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              v-if="form.app_route"
              small
              color="primary"
              text
              @click="openForm(form)"
            >
              <v-icon small class="mr-1">mdi-open-in-app</v-icon>Open
            </v-btn>
            <v-tooltip v-else top :disabled="!!form.has_file">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-btn
                    small
                    color="primary"
                    text
                    :disabled="!form.has_file"
                    :loading="downloadingId === form.id"
                    @click="printForm(form)"
                  >
                    <v-icon small class="mr-1">mdi-printer</v-icon>Print
                  </v-btn>
                </span>
              </template>
              <span>No template uploaded yet</span>
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      loading: false,
      downloadingId: null,
    };
  },
  computed: {
    ...mapGetters({
      my_forms: "printable_forms/my_forms",
    }),
  },
  methods: {
    ...mapActions({
      fetch_my_forms: "printable_forms/fetch_my_forms",
      download_form: "printable_forms/download_form",
    }),
    openForm(form) {
      this.$router.push(form.app_route);
    },
    async printForm(form) {
      this.downloadingId = form.id;
      try {
        await this.download_form(form);
      } catch (err) {
        this.$alert({
          title: "Error",
          message:
            err.response?.data?.message || "Failed to download the template",
          color: "error",
          icon: "mdi-alert-circle",
        });
      }
      this.downloadingId = null;
    },
    async refresh() {
      this.loading = true;
      try {
        await this.fetch_my_forms(true);
      } catch (e) {
        // Card stays hidden when the list can't be loaded.
      }
      this.loading = false;
    },
  },
  async created() {
    this.loading = true;
    try {
      await this.fetch_my_forms();
    } catch (e) {
      // Card stays hidden when the list can't be loaded.
    }
    this.loading = false;
  },
};
</script>
